import {jwtDecode} from "jwt-decode";
import toast from 'react-hot-toast';

export const getUser = (token) => {
  if (!token) return null;

  try {
    const decodedToken =  jwtDecode(token);
    return {decodedToken}
  } catch (error) {
    toast.error(error);
  }
};

export function truncateText(text, maxLength) {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
}

export function truncateHtml(html, maxLength) {
  if (!html) return "";
  
  // Create a temporary div to handle HTML content
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  
  // Get the text content
  const textContent = tempDiv.textContent || tempDiv.innerText;
  
  // Truncate the text
  if (textContent.length <= maxLength) return html;
  
  // Find the position in the HTML where we hit our text limit
  let pos = 0;
  let chars = 0;
  while (chars < maxLength && pos < html.length) {
    if (html[pos] === '<') {
      // Skip the tag
      while (pos < html.length && html[pos] !== '>') pos++;
    } else {
      chars++;
    }
    pos++;
  }
  
  // Return truncated HTML with proper closing
  return html.slice(0, pos) + '...';
}